import { Container } from '@cgs/wge';
import { T_GameStateMachineNotifierComponent } from '../../type_definitions';
import {
  AbstractListener,
  GameStateMachineNotifierComponent,
} from '../components/game_state_machine_notifier_component';
import { SLOT_SESSION_TOKEN, SlotSession } from './slot_session';

export class BaseListener<TListener> implements AbstractListener {
  ListenerController: TListener;
  protected _slotSession: SlotSession;
  private _notifierComponent: GameStateMachineNotifierComponent;

  constructor(container: Container) {
    console.log('load ' + this.constructor.name);
    this._notifierComponent = container.resolve<GameStateMachineNotifierComponent>(
      T_GameStateMachineNotifierComponent
    );
    this._slotSession = container.resolve<SlotSession>(SLOT_SESSION_TOKEN);
    this._notifierComponent.notifier.addListener(this);
  }

  onStateEntered(slotState: string): void {
    // TODO: implement onStateEntered
  }

  onStateExited(slotState: string): void {
    // TODO: implement onStateExited
  }
}
